'use client';

import * as React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';

import { Button } from '@/components/ui/button';

export default function SidebarThemeToggle() {
  const { theme, setTheme } = useTheme();
  
    return (
        <Button
              variant="ghost"
                    size="icon"
                          onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
                                className="h-[34px] w-[34px] rounded-full bg-neutral-200 text-muted-foreground transition hover:scale-105 dark:bg-white/5"
                                    >
                                          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                                                <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                                                      <span className="sr-only">Toggle theme</span>
                                                          </Button>
                                                            );
                                                            }
